import React from 'react';
import { connect } from 'react-redux';
import { branch, compose, renderNothing } from 'recompose';
import {
  Modal,
} from 'react-bootstrap';
import exact from 'prop-types-exact';

import PropTypes from 'prop-types';
import {
  dispatchHideGuaranteedTimeModal,
  dispatchChangeApprovalState,
} from '../actions';

import GuaranteedTimeForm from '../components/GuaranteedTimeForm';

const HOURLY_SALARY = 'hourly_salary';

const propTypes = exact({
  timesheet: PropTypes.object.isRequired,
  supervisorId: PropTypes.number.isRequired,
  showGuaranteedTimeModal: PropTypes.bool.isRequired,

  dispatchHideGuaranteedTimeModal: PropTypes.func.isRequired,
  dispatchChangeApprovalState: PropTypes.func.isRequired,
});

const AddGuaranteedTimeModal = (props) => {
  const {
    timesheet,
    supervisorId,
    showGuaranteedTimeModal,
    dispatchChangeApprovalState: approve,
    dispatchHideGuaranteedTimeModal: hide,
  } = props;

  const { user, payPeriodSummary } = timesheet;

  const { fullname, payroll_type: payrollType } = user;
  const { undertimeDuration, totalDuration, userTimesheets } = payPeriodSummary;
  const { to_string: undertimeDisplay } = undertimeDuration;
  const { to_string: totaltimeDisplay } = totalDuration;

  const isHourlySalary = (payrollType === HOURLY_SALARY);

  return (
    <Modal
      show={showGuaranteedTimeModal}
      onHide={hide}
      backdrop={false}
      aria-labelledby="contained-modal-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title">Add Guaranteed Time?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {fullname} has {totaltimeDisplay} total time for the pay period.
        </p>
        <br />
        { userTimesheets.map((ut) => {
          return (
            <div key={ut.id}>
              <p><strong>Week of {ut.startDate.display}</strong>: {ut.totalHours.to_string}</p>
            </div>
          );
        })}
        <br />
        {!isHourlySalary && (
          <p>
            You can add up to {undertimeDisplay} of guaranteed time
            for {fullname}.
          </p>
        )}
        {isHourlySalary && (
          <div>
            <p>
              You need to add {undertimeDisplay} of guaranteed time
              for {fullname}.
            </p>
            <p>
              <strong> Or, if you wish to add unpaid time </strong>,
              close the modal, select the employee and add unpaid time entries.
            </p>
          </div>
        )}
        <GuaranteedTimeForm
          hide={hide}
          timesheet={timesheet}
          supervisorId={supervisorId}
          approve={approve}
        />
      </Modal.Body>
    </Modal>
  );
};

AddGuaranteedTimeModal.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    showGuaranteedTimeModal: state.timesheetApprovals.showGuaranteedTimeModal,
    timesheet: state.timesheetApprovals.maybeApprovedTimesheet,
    supervisorId: state.timesheetApprovals.currentSupervisorId,
  };
};

const mapDispatchToProps = {
  dispatchHideGuaranteedTimeModal,
  dispatchChangeApprovalState,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withHide = branch(
  (props) => { return props.showGuaranteedTimeModal === false; },
  renderNothing,
);

const enhance = compose(
  withRedux,
  withHide,
);

export default enhance(AddGuaranteedTimeModal);
